const styles = {
  global: {
    'html, body': {
      fontSize: '14px',
      fontWeight: 500,
      scrollBehavior: 'smooth',
      margin: 0,
      padding: 0,
      MozOsxFontSmoothing: 'grayscale',
      webkitFontSmoothing: 'antialiased',
    },
    '*::placeholder': {
      color: 'inherit',
      opacity: '50%',
    },
    svg: {
      display: 'inline',
    },
  },
};

export default styles;
